import { Validator, NG_VALIDATORS, AbstractControl, ValidatorFn } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { FunctionUtils } from '@sharedcommon/util/functions.util';

@Directive({
    selector: '[maxvalue]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxValueValidatorDirective, multi: true }]
})
export class MaxValueValidatorDirective implements Validator {

    @Input() maxvalue: number;

    validate(control: AbstractControl): { [key: string]: any } | null {
        return FunctionUtils.isDefined(this.maxvalue) ? maxValueValidator(this.maxvalue)(control) : null;
    }
}

export function maxValueValidator(max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        return FunctionUtils.isDefined(control.value) && Number(control.value) > max ? { 'max': { value: control.value } } : null;
    };
}
